<pre>

4 attributes

-attack
-defence
-health
-energy


hp & energy are consumable
when leveling, can increment totals

costs energy to get past traps or attack

traps
-if hero attack > than trap attack AND hero defence > trap defence, bypass trap
-if hero attack > than trap defence, take energy, get exp
-if trap attack > than hero defence, take health

monsters

-if hero attack > than monster defence, apply diff as damage
-counter attaack of monster attack > hero defence

</pre>